
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const InfoCircleIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M52 30C52 32.2091 50.2091 34 48 34C45.7909 34 44 32.2091 44 30C44 27.7909 45.7909 26 48 26C50.2091 26 52 27.7909 52 30Z" fill="#161617"/>
<path d="M51.5 41.5C51.5 39.567 49.933 38 48 38C46.067 38 44.5 39.567 44.5 41.5V66.5C44.5 68.433 46.067 70 48 70C49.933 70 51.5 68.433 51.5 66.5V41.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M8 48C8 25.9086 25.9086 8 48 8C70.0914 8 88 25.9086 88 48C88 70.0914 70.0914 88 48 88C25.9086 88 8 70.0914 8 48ZM48 15C29.7746 15 15 29.7746 15 48C15 66.2254 29.7746 81 48 81C66.2254 81 81 66.2254 81 48C81 29.7746 66.2254 15 48 15Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M52 30C52 32.2091 50.2091 34 48 34C45.7909 34 44 32.2091 44 30C44 27.7909 45.7909 26 48 26C50.2091 26 52 27.7909 52 30Z" fill="#161617"/>
<path d="M51.5 41.5C51.5 39.567 49.933 38 48 38C46.067 38 44.5 39.567 44.5 41.5V66.5C44.5 68.433 46.067 70 48 70C49.933 70 51.5 68.433 51.5 66.5V41.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M8 48C8 25.9086 25.9086 8 48 8C70.0914 8 88 25.9086 88 48C88 70.0914 70.0914 88 48 88C25.9086 88 8 70.0914 8 48ZM48 15C29.7746 15 15 29.7746 15 48C15 66.2254 29.7746 81 48 81C66.2254 81 81 66.2254 81 48C81 29.7746 66.2254 15 48 15Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
